import React from 'react';

export function SectionCard({
  label,
  title,
  description,
  children,
  action,
  className,
}: {
  label: string;
  title: string;
  description?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <article className={`panel${className ? ` ${className}` : ''}`}>
      <div className="panelHeader">
        <div>
          <div className="panelKicker">{label}</div>
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
        {action}
      </div>
      {children}
    </article>
  );
}
